import { useState } from 'react';
import { MapPinIcon, ExternalLinkIcon } from 'lucide-react';
import { salon } from '../../data/content';
import { shopLabels } from '../../data/shopLabels';
import { mapEmbedUrl } from '../../core/rules/contact';
import { readLocal, writeLocal } from '../../core/storage';
import { btnPrimary } from '../../ui/styles';
type Props = {
  loadLabel: string;
  note: string;
};

/** Onthoudt dat de bezoeker de kaart al eens opende: dan hoeft ze niet steeds opnieuw te klikken. */
const CONSENT_KEY = 'bb-map-consent';

/**
 * Google-kaart met twee klikken: eerst een rustige plaat met het adres, pas na "Toon de kaart"
 * het echte frame. Google zet cookies en laadt ruim een megabyte; dat hoort niet zonder
 * toestemming te gebeuren (AVG), en niet op een telefoon die alleen het adres zocht.
 * "Open in Google Maps" werkt altijd, ook zonder de kaart te laden.
 */
export function SalonMap({
  loadLabel,
  note
}: Props) {
  const [loaded, setLoaded] = useState(() => readLocal(CONSENT_KEY) === '1');
  const address = salon.address || `${salon.street}, ${salon.postalCode} ${salon.locality}`;
  const load = () => {
    writeLocal(CONSENT_KEY, '1');
    setLoaded(true);
  };
  return <div className="relative aspect-[4/3] w-full overflow-hidden rounded-2xl border border-line bg-sand sm:aspect-[16/10] lg:aspect-[4/3]" data-id="element-7276" data-mp="1ih44hv1u1tli">
      {loaded ? <iframe src={mapEmbedUrl(address)} title={`Kaart: ${salon.name}, ${address}`} className="absolute inset-0 h-full w-full border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" allowFullScreen data-id="element-7277" data-mp="1nemdtmjriau1" /> : <div className="absolute inset-0 flex flex-col items-center justify-center px-8 text-center" data-id="element-7278" data-mp="zjt8cjbhzgaa">
          <MapPinIcon className="h-7 w-7 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-7279" data-mp="14huyfo7ccfv9" />
          <p className="mt-4 font-display text-xl leading-snug text-ink" data-id="element-7280" data-mp="2twssmpqtoynw">{salon.street}</p>
          <p className="mt-1 text-[15px] text-muted" data-id="element-7281" data-mp="2yu2rew03qmoe">
            {salon.postalCode} {salon.locality}
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-3" data-id="element-7282" data-mp="2xfru30rz7wvg">
            <button type="button" onClick={load} className={btnPrimary} data-id="element-7283" data-mp="2sdj2a7qub0ux">
              {loadLabel}
            </button>
            <a href={salon.routeUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 py-2 text-[14px] text-ink underline-offset-4 transition-colors duration-150 ease-soft hover:text-clay hover:underline" data-id="element-7284" data-mp="2ni3r5nk7vj27">
              Open in Google Maps
              <ExternalLinkIcon className="h-3.5 w-3.5" strokeWidth={1.5} aria-hidden="true" data-id="element-7285" data-mp="36e3lh50o2yoy" />
              <span className="sr-only" data-id="element-7286" data-mp="32dtcrklhpu6e"> {shopLabels.newTab}</span>
            </a>
          </div>
          {note && <p className="mt-5 max-w-xs text-[12px] leading-relaxed text-muted" data-id="element-7287" data-mp="2q1vj0phrsy1">{note}</p>}
        </div>}
    </div>;
}